const sortProductsByOdd = (a, b) => {
  if (!a.odd) {
    a.odd = 'none'
  }
  if (!b.odd) {
    b.odd = 'none'
  }
  const score = {
    excellent: 1,
    good: 2,
    fair: 3,
    poor: 4,
    none: 5
  }

  return score[a.odd] - score[b.odd]
}

module.exports = sortProductsByOdd
